import React from "react";

import {TextField, InputAdornment, FormControlLabel, FormLabel, RadioGroup, Radio, FormControl, Stack} from '@mui/material';
import DollarIcon from '@mui/icons-material/AttachMoney';
import LinkIcon from '@mui/icons-material/Link';

import '../../hoa-styles.scss';
import '../hoa-municipality-styles.scss'

interface MunicipalityAdditionalFormProps {
    state: any;
    setState: any;
    responsiveHeight: number;
}


export default function MunicipalityAdditionalForm(props : MunicipalityAdditionalFormProps) {
    const {state, setState} = props;

    const handleChange = (value: string, key: string) => {
        let tempState : any = state;
        tempState[key] = value;
        setState({...tempState});
    }

    const Wheel =(e: any) => {
        e.target.blur();
    }

    return (
        <div style={{ justifyContent: 'center', fontSize: '20px', width: "100%", height: "100%", boxSizing: "border-box" }}>
            <div style={{ display: 'flex', flexDirection: 'column', border: "1px solid #E8E8E8", borderRadius: "4px", width: "100%" }}>

                <div style={{ height:(window.innerHeight - props.responsiveHeight) ,  overflow:'scroll' }} className = "add-municipality-form-container">
                    <div className ="left-form-container">
                        <div className="sub-title-text" style={{marginBottom:"32px"}}>Inspection Requirements</div>

                        <Stack direction={'column'} paddingBottom={'5px'}>
                            <FormControl style={{ marginBottom: "24px" }}>
                                <FormLabel className="sub-title-text-2" style={{ marginBottom: "20px" }}>Is inspection mandatory for residential property?</FormLabel>
                                <RadioGroup
                                    row value={state.isInspectionMandatory}
                                    onChange={(e) => { handleChange(e.target.value, "isInspectionMandatory") }}
                                >
                                    <FormControlLabel value="Yes" control={<Radio color="primary" />} label="Yes" />
                                    <FormControlLabel value="No" control={<Radio color="primary" />} label="No" />
                                </RadioGroup>
                            </FormControl>

                            <FormControl>
                                <FormLabel className="sub-title-text-2" style={{ marginBottom: "20px" }}>Is self inspection available?</FormLabel>
                                <RadioGroup
                                    row value={state.iseSelfInspectionAvailable}
                                    onChange={(e) => { handleChange(e.target.value, "iseSelfInspectionAvailable") }}
                                >
                                    <FormControlLabel value="Yes" control={<Radio color="primary" />} label="Yes" />
                                    <FormControlLabel value="No" control={<Radio color="primary" />} label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Stack>

                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "space-between", alignItems:'flex-end'}}>
                            <TextField variant="standard" style={{ width: "45%", height:'64px', boxSizing:"border-box"}} value={state.inspectionFee} type='number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "inspectionFee")}} label="Inspection Fee" InputLabelProps={{style:{fontSize:"14px", margin:"auto 4px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                        <InputAdornment position="end">
                                            <DollarIcon />
                                        </InputAdornment>
                            )}}/>
                            <TextField variant="standard" style={{ width: "45%", height:'64px', boxSizing:"border-box"}} value={state.reInspectionFee} type='number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "reInspectionFee")}} label="Re-inspection Fee (in case of failed inspection)*" InputLabelProps={{style:{fontSize:"14px", margin:"auto 4px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                        <InputAdornment position="end">
                                            <DollarIcon />
                                        </InputAdornment>
                            )}}/>
                        </div>

                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "space-between" }}>
                            <TextField style={{ width: "45%" }} variant="standard" label="Inspection Schedule Method" value={state.inspectionScheduleMethod} required
                                onChange={(e)=>{handleChange(e.target.value, "inspectionScheduleMethod")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}}/>
                            <></>
                        </div>

                        <div className="sub-title-text" style={{marginBottom:"32px"}}>Inspection Criteria</div>
                        <div className="sub-title-text-2" style={{marginBottom:"24px"}}>Exterior Inspection</div>
                        <TextField style={{ width: "75%", marginBottom:"24px"}} variant="outlined" value={state.exteriorInspection}
                            onChange={(e) => { handleChange(e.target.value, "exteriorInspection") }} label="Write here..." multiline
                            InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} InputProps={{ style: { minHeight:"106px" } }}/>
                        <div className="sub-title-text-2" style={{marginBottom:"24px"}}>Interior Inspection</div>
                        <TextField style={{ width: "75%", marginBottom:"24px"}} variant="outlined" value={state.interiorInspection}
                            onChange={(e) => { handleChange(e.target.value, "interiorInspection") }} label="Write here..." multiline
                            InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} InputProps={{ style: { minHeight:"106px" } }}/>

                        <div className="sub-title-text" style={{marginBottom:"32px"}}>Code of Compliance</div>
                        <FormControl style={{marginBottom:"24px"}}>
                            <FormLabel className="sub-title-text-2" style={{marginBottom:"20px"}}>Is there a requirement of Code Compliance in the Municipality?</FormLabel>
                            <RadioGroup
                                row value={state.isCodeOfComplianceRequired}
                                onChange={(e)=>{handleChange(e.target.value, "isCodeOfComplianceRequired")}}
                            >
                                <FormControlLabel value="Yes" control={<Radio color="primary"/>} label="Yes" />
                                <FormControlLabel value="No" control={<Radio color="primary"/>} label="No" />
                            </RadioGroup>
                        </FormControl>
                        <TextField variant="standard" style={{ width: "75%" }} value={state.commonCodeViolations} disabled = {state.isCodeOfComplianceRequired !== "Yes"}
                            onChange={(e) => { handleChange(e.target.value, "commonCodeViolations") }} label="Common Code Violations" InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <LinkIcon />
                                    </InputAdornment>
                            )}} />
                    </div>

                    <div className='right-form-container'>
                        <div className="sub-title-text" style={{marginBottom:"24px"}}>Rental Certificates</div>

                        <FormControl style={{marginBottom:"24px"}}>
                            <FormLabel className="sub-title-text-2" style={{marginBottom:"20px"}}>Is rental certificate of occupancy needed?</FormLabel>
                            <RadioGroup
                                row value={state.isRentalCertificateNeeded}
                                onChange={(e)=>{handleChange(e.target.value, "isRentalCertificateNeeded")}}
                            >
                                <FormControlLabel value="Yes" control={<Radio color="primary"/>} label="Yes" />
                                <FormControlLabel value="No" control={<Radio color="primary"/>} label="No" />

                            </RadioGroup>
                        </FormControl>
                        <FormControl style={{marginBottom:"24px"}}>
                            <FormLabel className="sub-title-text-2" style={{marginBottom:"20px"}}>Are outstanding tax payments allowed?</FormLabel>
                            <RadioGroup
                                row value={state.isOutstandingTaxPaymentAllowed}
                                onChange={(e)=>{handleChange(e.target.value, "isOutstandingTaxPaymentAllowed")}}
                            >
                                <FormControlLabel value="Yes" control={<Radio color="primary"/>} label="Yes" />
                                <FormControlLabel value="No" control={<Radio color="primary"/>} label="No" />

                            </RadioGroup>
                        </FormControl>
                        <FormControl style={{marginBottom:"24px"}}>
                            <FormLabel className="sub-title-text-2" style={{marginBottom:"20px"}}>Are outstanding violations/payments allowed?</FormLabel>
                            <RadioGroup
                                row value={state.isOutstandingViolationAllowed}
                                onChange={(e)=>{handleChange(e.target.value, "isOutstandingViolationAllowed")}}
                            >
                                <FormControlLabel value="Yes" control={<Radio color="primary"/>} label="Yes" />
                                <FormControlLabel value="No" control={<Radio color="primary"/>} label="No" />

                            </RadioGroup>
                        </FormControl>
                        <FormControl style={{marginBottom:"24px"}}>
                            <FormLabel className="sub-title-text-2" style={{marginBottom:"20px"}}>Is there Pre-Occupancy Penalty for occupation of property before obtaining Rental Certificate of Occupancy?</FormLabel>
                            <RadioGroup
                                row value={state.preOccupencyPenalty}
                                onChange={(e)=>{handleChange(e.target.value, "preOccupencyPenalty")}}
                            >
                                <FormControlLabel value="Yes" control={<Radio color="primary"/>} label="Yes" />
                                <FormControlLabel value="No" control={<Radio color="primary"/>} label="No" />

                            </RadioGroup>
                        </FormControl>
                        <FormControl style={{marginBottom:"24px"}}>
                            <FormLabel className="sub-title-text-2" style={{marginBottom:"20px"}}>Is it required to have local agent as contact?</FormLabel>
                            <RadioGroup
                                row value={state.isLocalAgentRequired}
                                onChange={(e)=>{handleChange(e.target.value, "isLocalAgentRequired")}}
                            >
                                <FormControlLabel value="Yes" control={<Radio color="primary"/>} label="Yes" />
                                <FormControlLabel value="No" control={<Radio color="primary"/>} label="No" />

                            </RadioGroup>
                        </FormControl>
                    </div>
                </div>
            </div>
        </div>
    )
}